import React from 'react';
import { Rnd } from 'react-rnd';

const WrapChild = ({
  children,
  prop,
  dimensions,
  type,
  setActiveZone,
  size,
  image,
  activeIndex,
  setScreenType,
  isHasError,
}) => {
  const ref = React.useRef();
  let dragState = false;
  let resizeState = false;
  const currentW = type === 'Hotspot' ? parseInt(size) : parseInt(prop.data.width) || 100;
  const currentH = type === 'Hotspot' ? parseInt(size) : parseInt(prop.data.height) || 100;
  const updateBoundaries = (prop, boundary, dimensions) => {
    const obj = {
      x: boundary.x,
      y: boundary.y,
      w: currentW,
      h: currentH,
    };
    dimensions(obj, prop.id);
    updatePropValue(obj);
    dragState = false;
  };

  const updatePropValue = (obj) => {
    const updateProp = { ...prop.data };
    updateProp.x = obj.x;
    updateProp.y = obj.y;
    updateProp.width = obj.w;
    updateProp.height = obj.h;
  };

  const updateBoundsOnResize = (id, style, position) => {
    const obj = {
      x: position.x,
      y: position.y,
      w: style.width,
      h: style.height,
    };
    updatePropValue(obj);
    dimensions(obj, id);
    resizeState = false;
  };

  const child = React.Children.only(children);
  const minWidth = image?.width >= 100 ? 100 : image?.width;
  const minHeight = image?.height >= 100 ? 100 : image?.height;
  const sizeDimension = {
    width: type === 'Hotspot' ? size : prop.data.width,
    height: type === 'Hotspot' ? size : prop.data.height,
  };
  const computedClassName =
    activeIndex === prop.id ? (isHasError ? `active-${type}-error` : `active-${type}`) : '';
  const imgElement = document.getElementById('dndImage');
  const rect = imgElement?.getBoundingClientRect();

  const imgW = rect?.width || 0;
  const imgH = rect?.height || 0;
  const safeX = Math.max(0, Math.min(prop.data.x || 0, imgW - currentW));
  const safeY = Math.max(0, Math.min(prop.data.y || 0, imgH - currentH));
  return (
    <Rnd
      id={`rnd_${prop.id}`}
      style={{
        backgroundColor: 'transparent',
        display: 'inline-block',
        border: isHasError ? '2px solid #C53330' : '2px solid #112299',
        position: 'absolute',
        zIndex: activeIndex === prop.id ? 1000 : 1,
      }}
      className={computedClassName}
      position={{ x: safeX, y: safeY }}
      size={sizeDimension}
      bounds='.boundry.centered-div'
      minWidth={type === 'Hotspot' ? size : minWidth}
      minHeight={type === 'Hotspot' ? size : minHeight}
      maxWidth={imgW || '100%'}
      maxHeight={imgH || '100%'}
      enableResizing={type === 'Hotspot' ? false : true}
      onGotPointerCapture={() => setActiveZone(prop.id)}
      onClick={(e) => {
        setActiveZone(prop.id);
        setScreenType('editDetails');
      }}
      onDrag={() => (dragState = true)}
      onDragStop={(e, boundaries) => {
        if (!dragState) return;
        updateBoundaries(prop, boundaries, dimensions);
      }}
      onResize={() => (resizeState = true)}
      onResizeStop={(e, direction, ref, delta, position) => {
        if (!resizeState) return;
        updateBoundsOnResize(prop.id, ref.style, position);
      }}
    >
      <div>{React.cloneElement(child, { ref })}</div>
    </Rnd>
  );
};

export default WrapChild;
